import { render } from "./LoaderList.vue?vue&type=template&id=717a5f5e"
import script from "./LoaderList.vue?vue&type=script&lang=js"
export * from "./LoaderList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__